<div class="search-box_container">
  <div class="search-box_toolbar">

    <div class="search-box_bar search-box_bar--large button-primary button-primary--white">
      <input
        #searchInput 
        type="text" 
        [placeholder]="'Search styles'"
        (keyup)="onSearch()"
        (keydown.enter)="onSearch()">
        <div 
          class="search-box_icon-search"
          (click)="onSearch()">
          <svg width="20px" viewBox="0 0 20 20" aria-hidden="true" role="presentation"><path d="M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z"></path></svg>
        </div>
      <div 
        class="search-box_icon-close"
        (click)="onClearSearch()">
        <fa-icon [icon]="['fal', 'times']"></fa-icon>
      </div>
    </div>

    <button
      class="button-primary button-primary--white" 
      (click)="onFavoritesToggle()">
      <fa-icon 
        [icon]="stylesService.isFavoritesView ? ['fas', 'heart'] : ['fal', 'heart']"
        class="text--grey"> 
      </fa-icon>
    </button>

  </div>
</div>

<div class="content-wrapper content-wrapper--sm">
  <ng-container *ngIf="(!isBibliographyUpdating && !stylesService.stylesLoading), else loadingTemplate">
    <div 
      #styleList
      id="scroll-wrapper-styles"
      *ngIf="!stylesService.isFavoritesView"
      class="scroll-wrapper scroll-wrapper--xs scrollbar padding-top-sm"
      infiniteScroll
      [scrollOffset]="200"
      [debounceTime]="15"
      [onScrollCallback]="onScrollDown.bind(this)">

      <ng-container *ngIf="displayedCustomStyles.length">
        <div class="label">Custom styles</div>
        <div 
          *ngFor="let style of displayedCustomStyles" 
          class="button button--large button--has-addon block text--sm"
          (click)="onSelectStyle(style)">
          <fa-icon 
            *ngIf="style?.id?.indexOf('org-') === 0" 
            [icon]="['fas', 'users']">
          </fa-icon>
          {{ style?.title }}
          <div 
            *ngIf="!style.isFavoriteStatusLoading"
            class="button_icon"
            (click)="onStyleFavoriteClick(style, $event, true)">
            <fa-icon 
              [icon]="style.isFavorite ? ['fas', 'heart'] : ['fal', 'heart']"
              class="text--grey"> 
            </fa-icon>
          </div>
          <div
            *ngIf="style.isFavoriteStatusLoading" 
            class="button_icon">
            <scs-loader [isSmall]="true"></scs-loader>
          </div>
        </div>
      </ng-container>
  
      <ng-container *ngIf="mergedStyles.length">
        <div class="label">All styles</div>
        <div 
          *ngFor="let style of mergedStyles" 
          class="button button--large button--has-addon block text--sm"
          (click)="onSelectStyle(style)">
          {{ style?.title }}
          <div 
            *ngIf="!style.isFavoriteStatusLoading"
            class="button_icon"
            (click)="onStyleFavoriteClick(style, $event)">
            <fa-icon 
              [icon]="style.isFavorite ? ['fas', 'heart'] : ['fal', 'heart']"
              class="text--grey"> 
            </fa-icon>
          </div>
          <div
            *ngIf="style.isFavoriteStatusLoading" 
            class="button_icon">
            <scs-loader [isSmall]="true"></scs-loader>
          </div>
        </div>
      </ng-container>
  
    </div>
  
    <div 
      #styleFavoriteList 
      *ngIf="stylesService.isFavoritesView"
      class="scroll-wrapper scroll-wrapper--xs scrollbar padding-top-sm">

      <div class="label">Favorite custom styles</div>
      <div *ngIf="!favoriteCustomStyles.length" class="text--center text--sm">
        <i>Currently there are no favorite custom styles.</i>
      </div>
      <div 
        *ngFor="let style of favoriteCustomStyles" 
        class="button button--large button--has-addon block text--sm"
        (click)="onSelectStyle(style)">
        <fa-icon 
          *ngIf="style?.id?.indexOf('org-') === 0" 
          [icon]="['fas', 'users']">
        </fa-icon>
        {{ style?.title }}
        <div 
          *ngIf="!style.isFavoriteStatusLoading"
          class="button_icon"
          (click)="onStyleFavoriteClick(style, $event, true)">
          <fa-icon 
            [icon]="['fas', 'heart']"
            class="text--grey"> 
          </fa-icon>
        </div>
        <div
          *ngIf="style.isFavoriteStatusLoading" 
          class="button_icon">
          <scs-loader [isSmall]="true"></scs-loader>
        </div>
      </div>
  
      <div class="label">Favorite styles</div>
      <div *ngIf="!favoriteStyles.length" class="text--center text--sm">
        <i>Currently there are no favorite styles.</i>
      </div>
      <div 
        *ngFor="let style of favoriteStyles" 
        class="button button--large button--has-addon block text--sm"
        (click)="onSelectStyle(style)">
        {{ style?.title }}
        <div 
          *ngIf="!style.isFavoriteStatusLoading"
          class="button_icon"
          (click)="onStyleFavoriteClick(style, $event)">
          <fa-icon 
            [icon]="['fas', 'heart']"
            class="text--grey"> 
          </fa-icon>
        </div>
        <div
          *ngIf="style.isFavoriteStatusLoading" 
          class="button_icon">
          <scs-loader [isSmall]="true"></scs-loader>
        </div>
      </div>
  
    </div>
  
    <div #styleDrawer class="drawer">
      <div class="drawer_header">

        <ng-container *ngIf="!isStyleSelectLoading">
          <small class="uppercase">selected style:</small> 
          <strong>
            &nbsp;{{ selectedStyle?.title }}
          </strong>
        </ng-container>

        <scs-loader [isSmall]="true" *ngIf="isStyleSelectLoading"></scs-loader>

        <span *ngIf="!selectedStyle">
          &nbsp; <i>No style is currently selected.</i>
        </span>

      </div>
      
      <div 
        class="button-primary button-primary--sm uppercase"
        (click)="onUpdateBibliography()">
        Update bibliography
      </div>
    </div>
  </ng-container>
</div>

<ng-template #loadingTemplate>
  <div class="loader_overlay">
    <scs-loader class="center-horizontal-vertical"></scs-loader>
  </div>
</ng-template>